export enum ShowType {
  NONE = 'NONE',
  SEARCH = 'action.search',
  DETAILTREND = 'action.searchTrend',
  SUMMARY = 'action.summary',
  TREND = 'action.trend',
  PLTDISTTREND = 'action.pltDistTrend',
  STORE = 'action.store',
  HOTWORDS = 'action.wordcloud',
  STOREINFO = 'action.storeInfo',
  STORETREND = 'action.storeTrend',
  TOPSKU = 'action.topsku',
  SNAPSHOTDOWNLOAD = 'action.snapshotDownload',
  SNAPSHOT = 'action.snapshot',
  PRICE = 'action.priceTracking',
  SNAPSHOTTREND = 'action.snapshotTrend',
  PRICETREND = 'action.priceTrend',
  KOL = 'action.kol',
  KOLBRAND = 'action.kolBrand',
  ADS = 'action.adsTracking',
  SHL = 'action.shortHeadlineTracking',
  BRANDCATEPERFORMANCE='action.brandCatePerformance',
  PLATFORMPERFORMANCE='action.platformPerformance'
}
